import { useApiStore } from '@/stores/apiStore';
import { CompassDevicesApi } from '@/../generated-client/apis/CompassDevicesApi';

import { ResponseError } from '@/../generated-client/runtime';
import { MacLookupOnAzure } from '../../generated-client/models';

let compassDevicesApi: CompassDevicesApi | null = null;
let lastConfig: unknown = null;

function getCompassDevicesApi(): CompassDevicesApi {
  const { apiConfig } = useApiStore.getState();

  if (compassDevicesApi === null || lastConfig !== apiConfig) {
    compassDevicesApi = new CompassDevicesApi(apiConfig);
    lastConfig = apiConfig;
  }

  return compassDevicesApi;
}

export const getCompassDeviceByMacAddress = async (
  macAddress: string,
): Promise<MacLookupOnAzure | null> => {
  const api = getCompassDevicesApi();
  try {
    return await api.apiCompassDevicesGetByMacAddressGet({ macAddress });
  } catch (error) {
    if (error instanceof ResponseError && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};
